import { createRoot, type Root } from 'react-dom/client';
import { App } from './App';
import { initSentry } from './shared/sentry';
import type { MountProps } from './types';
import './styles.css';

const roots = new WeakMap<HTMLElement, Root>();

export function mount(el: HTMLElement, props: MountProps): { unmount: () => void } {
  initSentry(props.sentry);

  const existing = roots.get(el);
  if (existing) existing.unmount();

  const root = createRoot(el);
  root.render(<App {...props} />);
  roots.set(el, root);

  return {
    unmount: () => {
      roots.get(el)?.unmount();
      roots.delete(el);
    },
  };
}

window.MoveekBooking = { mount, version: __APP_VERSION__ };
